<template>
	<div>
		<daohang :tabIndex="tabIndex" @selected='xuanze'></daohang>
		<div class="content">
			<home v-if="tabIndex==0"></home>
			<guanyu v-if="tabIndex==1"></guanyu>
			<lianxi v-if="tabIndex==2"></lianxi>
		</div>
		<qkw-footer @selected='xuanze'></qkw-footer>
	</div>
</template>

<script>
	import daohang from "@/components/daohang.vue";
	import qkwFooter from "@/components/qkw-footer.vue";
	import home from "../home/home.vue";
	import guanyu from "../guanyu/guanyu.vue"
	import lianxi from "../lianxi/lianxi.vue";
	export default {
		components: {
			daohang,
			qkwFooter,
			home,
			guanyu,
			lianxi
		},
		data() {
			return {
				tabIndex: 0
			};
		},
		mounted() {
			this.tabIndex = Number(localStorage.getItem('index'))
		},
		methods: {
			xuanze(e) {
				this.tabIndex = e
			}
		}
	};
</script>

<style scoped lang="less">
	.content {
		min-height: calc(100vh - 300px);
		background-color: #FEE1E3;
	}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue